import { HorizontalSection } from '@/components/display/horizontal-section';
import { SuggestedFriendCard } from '@/features/friends/components/suggested-friend-card';
import { useFriendActions } from '@/features/friends/hooks/use-friend-actions';
import { useSuggestedFriends } from '@/features/friends/hooks/use-suggested-friends';
import { useCallback, useMemo } from 'react';

export function SuggestedFriends() {
    const { sendRequest } = useFriendActions();

    const handleAddFriend = useCallback((userId: string) => {
        sendRequest.mutate(userId);
    }, [sendRequest]);

    const { data: suggestedFriends } = useSuggestedFriends(10);

    const suggestedFriendsSection = useMemo(() => {
        if (!suggestedFriends || suggestedFriends.length === 0) return null;
        return (
        <HorizontalSection title="People You May Know">
            {suggestedFriends.map((suggestion) => (
            <SuggestedFriendCard
                key={suggestion.userId}
                suggestion={suggestion}
                onAddFriend={handleAddFriend}
                isPending={sendRequest.isPending && sendRequest.variables === suggestion.userId}
            />
            ))}
        </HorizontalSection>
        );
    }, [suggestedFriends, handleAddFriend, sendRequest.isPending, sendRequest.variables]);

    return suggestedFriendsSection;
}
